import axios from "axios";

const baseURL = process.env.REACT_APP_MOODLE_API;

export const moodleInstanceApi = axios.create({
  baseURL: baseURL,
  params: {
    moodlewsrestformat: "json",
  },
});

export const resetPasswordInstanceApi = axios.create({
  baseURL: `${baseURL}local/forgotpassword/api.php`,
});

resetPasswordInstanceApi.interceptors.request.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
)

moodleInstanceApi.interceptors.request.use(
  (config) => {
    const wstoken = sessionStorage.getItem("wstoken");

    // Use sessionStorage token first, fallback to env token
    const finalToken = wstoken;

    if (finalToken) {
      config.params = {
        ...config.params,
        wstoken: finalToken
      };
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
moodleInstanceApi.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Only log errors in development
    if (process.env.NODE_ENV === 'development') {
      console.error('Moodle API Error:', error.response?.status, error.message);
    }
    return Promise.reject(error);
  }
);
